import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Menu, X } from 'lucide-react';
import Logo from './Logo';
import UserMenu from './UserMenu';
import { useAuth } from '../hooks/useAuth';

export default function Navbar() {
  const { user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav className="bg-white/95 backdrop-blur-sm shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center h-16">
          {/* Mobile menu button - moved to left */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-[#9CCC57] transition-colors p-2 -ml-2"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>

          {/* Logo and Nav Links Container */}
          <div className="flex items-center flex-1 md:ml-0 ml-2">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <Logo showText={false} size="sm" />
            </Link>

            {/* Desktop navigation links - left aligned */}
            <div className="hidden md:flex items-center ml-6">
              <Link 
                to="/plants" 
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4"
              >
                Plants
              </Link>
              <Link 
                to="/collections" 
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4"
              >
                Collections
              </Link>
              <Link 
                to="/blog" 
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4 blog-section"
              >
                Articles
              </Link>
              <Link
                to="/shop"
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4 shop-section"
              >
                Resources
              </Link>
              <a
                href="/#tools"
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4"
              >
                Tools
              </a>
              <a
                href="https://shop.bloomagrows.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#9CCC57] transition-colors px-4"
              >
                Shop
              </a>
            </div>
          </div>

          {/* Right section */}
          <div className="flex items-center space-x-4 md:space-x-6">
            {user ? (
              <>
                <Link 
                  to="/my-garden" 
                  className="flex items-center gap-2 bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600 transition-colors my-garden-button"
                >
                  <Sprout className="h-5 w-5" />
                  <span className="hidden md:inline">My Garden</span>
                </Link>
                <UserMenu />
              </>
            ) : (
              <>
                <Link 
                  to="/my-garden"
                  className="text-gray-600 hover:text-[#9CCC57] transition-colors my-garden-button"
                >
                  <Sprout className="h-5 w-5" />
                </Link>
                <Link 
                  to="/auth" 
                  className="hidden md:flex bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600 transition-colors text-sm"
                >
                  Sign In
                </Link>
              </>
            )}
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t">
            <div className="py-2 space-y-1">
              <Link 
                to="/plants"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Plants
              </Link>
              <Link 
                to="/collections"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Collections
              </Link>
              <Link 
                to="/blog"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50 blog-section"
                onClick={() => setIsMenuOpen(false)}
              >
                Articles
              </Link>
              <Link
                to="/shop"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50 shop-section"
                onClick={() => setIsMenuOpen(false)}
              >
                Resources
              </Link>
              <a
                href="/#tools"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Tools
              </a>
              <a
                href="https://shop.bloomagrows.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 text-gray-600 hover:bg-gray-50"
                onClick={() => setIsMenuOpen(false)}
              >
                Shop
              </a>
              {user ? (
                <Link 
                  to="/my-garden"
                  className="block px-4 py-2 bg-primary-500 text-white hover:bg-primary-600"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <div className="flex items-center gap-2">
                    <Sprout className="h-5 w-5" />
                    <span>My Garden</span>
                  </div>
                </Link>
              ) : (
                <Link 
                  to="/auth"
                  className="block px-4 py-2 text-primary-600 hover:bg-primary-50 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign In
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}